<!-- Events -->
<!-- itemCreated -->

<template>
  <v-container
    class="no-gutters"
    v-resize="onResize"
    fluid
  >
    <v-card
      class="px-3"
      flat
    >
      <v-row>
        <v-col cols="12">
          <h3>Customer Search</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="9"
        >
          <v-text-field
            v-model="searchValue"
            @keyup.enter="doGetPowCustomerSearch"
          >
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-btn
            @click="doGetPowCustomerSearch"
          >
            SEARCH
          </v-btn>
          <v-btn
            @click="drawerFilterSearch = !drawerFilterSearch"
          >
            Filters
          </v-btn>

          <v-checkbox
            v-model="useCache"
            :label="`Use Cache`"
          ></v-checkbox>
        </v-col>
        <v-col
          v-if="enabledFilterString.length > 0"
          cols="12"
        >
          <p class="section-bullets">Enabled Filters</p>
          <p style="color: firebrick">{{ enabledFilterString }}</p>
        </v-col>
        <v-col>
          <v-data-table
            :headers="headersCustomerResults"
            :items="searchResults"
            :items-per-page="50"
            item-key="tempkey"
            sort-by="cust_name"
            class="elevation-1"
            show-group-by
            fixed-header
            :height="tableHeight"
          >
            <template v-slot:item.cust_name="{ item }">
              <pow-plat-account-actions :custId="item.cust_id">{{item.cust_id + ' - ' + item.cust_name}}</pow-plat-account-actions>
            </template>
            <template v-slot:item.cust_active="{ item }">
              <base-tt-icon
                v-if="item.cust_active && item.cust_active.toLowerCase() === 'y'"
                tooltip="Active"
                color="green"
                :tooltip-delay="150"
                icon="mdi-play-circle"
              ></base-tt-icon>
              <base-tt-icon
                v-if="item.cust_active && item.cust_active.toLowerCase() === 's'"
                color="orange darken-1"
                tooltip="Suspended"
                :tooltip-delay="150"
                icon="mdi-pause-circle"
              ></base-tt-icon>
              <base-tt-icon
                v-if="item.cust_active && item.cust_active.toLowerCase() === 'h'"
                color="brown darken-1"
                tooltip="Suspended"
                :tooltip-delay="150"
                icon="mdi-alert"
              ></base-tt-icon>
              <base-tt-icon
                v-if="item.cust_active && item.cust_active.toLowerCase() === 'n'"
                color="red darken-2"
                tooltip="Inactive"
                :tooltip-delay="150"
                icon="mdi-stop-circle"
              ></base-tt-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-overlay
        :value="overlayDisplay"
        :absolute="overlayAbsolute"
      >
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>

  </v-container>
</template>

<script>
  // Utilities
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import {
    SEARCH_SET_QUERY, SEARCH_SET_USE_CACHE, SEARCH_SET_FILTERS,
  } from '../../store/mutations.types'
  import {
    _COMMIT_LOG, SEARCH_POST_QUERY, SEARCH_POST_QUERY_CSV,
  } from '../../store/actions.types'
  import basicMixin from '../../mixins/basic'
  // import { NotUnique } from '@/errors/bucketErrors'

  export default {
    name: 'PowCustomerSearchTable',
    components: {
      // powAccessPointForm: () => import('@/components/pow/AccessPointForm'),
      powPlatAccountActions: () => import('@/components/pow/PlatAccountActions'),
    },
    mixins: [basicMixin],
    inheritAttrs: false,
    props: {
      query: {
        type: String,
        default: '',
      },
    },
    data: function () {
      return {
        dialogNew: false,
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
        headersCustomerResults: [
          // {
          //   text: 'Id',
          //   align: 'start',
          //   sortable: true,
          //   groupable: false,
          //   value: 'cust_id',
          // },
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'cust_name',
          },
          {
            text: 'Active',
            align: 'center',
            sortable: true,
            groupable: false,
            value: 'cust_active',
          },
          {
            text: 'Address',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'cust_addr1',
          },
          {
            text: 'City',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'cust_city',
          },
          {
            text: 'Phone',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'cust_phone',
          },
          {
            text: 'Tower',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'tower_name',
          },
          {
            text: 'AP',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'wireless_ap',
          },
          {
            text: 'Radius',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'ppp_radiusgroup',
          },
          {
            text: 'IP',
            align: 'center',
            sortable: true,
            groupable: false,
            value: 'ppp_ip',
          },
          {
            text: 'Email',
            align: 'center',
            sortable: true,
            groupable: false,
            value: 'cust_email',
          },
          {
            text: 'Plan',
            align: 'center',
            sortable: true,
            groupable: true,
            value: 'rate_name',
          },
          {
            text: 'Dist',
            align: 'center',
            sortable: true,
            groupable: false,
            value: '_distance',
          },
          // {
          //   text: 'Actions',
          //   align: 'center',
          //   sortable: false,
          //   groupable: false,
          //   value: '_actions',
          // },
        ],
      }
    },
    computed: {
      ...mapGetters({
        searchFilters: 'search_filters',
        searchUseCache: 'search_useCache',
        searchUseCenter: 'search_useCenter',
        searchUseDistance: 'search_useDistance',
        searchQuery: 'search_query',
        searchResults: 'search_results',
        enabledFilters: 'search_enabledFilters',
      }),
      powUrl: {
        get () {
          return `${process.env.VUE_APP_API_POW_URL}`
        },
      },
      enabledFilterString: {
        get () {
          let output = ''
          for (const filter in this.enabledFilters) {
            if (this.enabledFilters[filter] === true) {
              if (output.length > 0) {
                output += ', '
              }
              output += filter
            }
          }
          return output
        },
      },
      searchValue: {
        // getter
        get: function () {
          return this.searchQuery
        },
        // setter
        set: function (newValue) {
          this.setQuery(newValue)
        },
      },
      useCache: {
        // getter
        get: function () {
          return this.searchUseCache
        },
        // setter
        set: function (newValue) {
          this.setUseCache(newValue)
        },
      },
      tableHeight () {
        return this.windowSize.y - 350 + 'px'
      },
    },
    watch: {
      searchFilters: {
        handler: function (val, oldVal) {
          this.setFilters(val)
        },
        deep: true,
      },
    },
    async created () {
    },
    methods: {
      ...mapActions({
        commitLog: _COMMIT_LOG,
        getPowCustomerSearch: SEARCH_POST_QUERY,
        getPowCustomerSearchCSV: SEARCH_POST_QUERY_CSV,
      }),
      ...mapMutations({
        setFilters: SEARCH_SET_FILTERS,
        setQuery: SEARCH_SET_QUERY,
        setUseCache: SEARCH_SET_USE_CACHE,
      }),
      async doGetPowCustomerSearch () {
        try {
          this.overlayDisplay = true
          await this.getPowCustomerSearch({ query: this.searchValue, useCache: this.useCache })
          this.overlayDisplay = false
          this.$emit('resultsReturned', [...this.searchResults])
        } catch (e) {
          this.commitLog(e)
        }
      },
      async doGetCSV () {
        try {
          this.overlayDisplay = true
          await this.getPowCustomerSearchCSV()
          this.overlayDisplay = false
          this.$emit('resultsReturned', [...this.searchResults])
        } catch (e) {
          this.commitLog(e)
        }
      },
      resetForm () {
      },
    },
  }
</script>

<style>
</style>
